var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"start"},[_c('img',{staticClass:"start_img",attrs:{"src":require("../../../static/img/00.jpg")}}),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('img',{attrs:{"src":require("../../../static/img/000.png")},on:{"click":_vm.go}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-597f6eef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/start/start.vue
// module id = null
// module chunks = 